export const getCoursesCalendarSlotsPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/courses-calendar/slots`;

export const getCoursesCalendarCreateRidePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/courses-calendar/create-ride`;
